<template>
  <v-container>
    <div class="text-center">
      <v-row>
        <v-col
                lg="4"
            md="5"
                sm="12"
        >
          <v-text-field
                  label="Purchase price"
                  messages="Down payment + loan amount"
                  v-model="data.listingPrice"
                  prefix="$"
                  type="number"
                  step="1000"
                  @keyup="updateListingPrice"
          >

          </v-text-field>
         <br/>
          <v-card
                  cols="4"
                  xs12
                  md6>

            <v-subheader>Loan Specific</v-subheader>
            <v-container fluid grid-list-lg>
              <v-text-field
                      label="Closing Cost(including down payment)"
                      v-model="data.closingCost"
                      prefix="$"
                      type="number"
                      step="100"
              >
              </v-text-field>

              <v-text-field
                          label="Down Payment Percent"
                          messages=""
                          suffix="%"
                          type="number"
                          step="0.01"
                          max="100"
                          min="0"
                          @keyup="updateDownPaymentPercent"
                          v-model="data.downPaymentPercent"
                  >

                  </v-text-field>

                  <v-text-field
                          label="Down Payment Amount"
                          v-model="data.downPaymentAmount"
                          prefix="$"
                          @keyup="updateDownPaymentAmount"
                          type="number"
                          step="1000"
                  >

                  </v-text-field>


                  <v-text-field
                          label="Loan Amount"
                          v-model="data.loanAmount"
                          prefix="$"
                          type="number"
                          step="1000"
                          @keyup="updateLoanAmount"
                  >

                  </v-text-field>

                  <v-combobox
                          v-model="data.term"
                          type="number"
                          label="Term"
                          :items="terms"
                          suffix="years"
                  >

                  </v-combobox>


                  <v-text-field
                          label="Interest Rate"
                          suffix="%"
                          type="number"
                          step="0.01"
                          max="100"
                          min="0"
                          v-model="data.rate"
                  >

                  </v-text-field>

                  <v-text-field
                          label="Private Mortgage Insurance (PMI)"
                          v-model="data.pmi"
                          prefix="$"
                          type="number"
                          step="1000"
                          suffix="/month"
                  >

                  </v-text-field>

                  <v-text-field
                          label="Extra money per month"
                          messages="towards principal"
                          v-model="data.extraPerMonth"
                          prefix="$"
                          type="number"
                          step="1"
                          suffix="/month"
                  >

                  </v-text-field>
              <v-chip
                      v-if="data.payoffMonth"
                      class="ma-2"
                      color="red accent-1"
                      text-color="white"
              >
                Pay off loan: {{data.payoffMonth}}m or {{parseInt(data.payoffMonth/12)}}y {{data.payoffMonth % 12}}m earlier
              </v-chip>
              <v-chip
                      v-if="data.originalInterest != data.interestPaidArray[data.interestPaidArray.length - 1]"
                      class="ma-2"
                      color="red accent-1"
                      text-color="white"
              >
                Pay ${{(data.originalInterest - data.interestPaidArray[data.interestPaidArray.length - 1]).toLocaleString()}} less
              </v-chip>

              <br/>
              <v-btn rounded
                     color="primary"
                     dark
                     @click="calculate"
              >Calculate</v-btn>

            </v-container>
          </v-card>
        </v-col>
        <v-col
        lg="8"
        md="7"
        sm="12"
        >
          <v-chip
                  class="ma-2"
                  color="indigo"
                  text-color="white"
          >
            Monthly P+I+PMI: ${{ (Number(data.monthlyPayment) + Number(data.pmi)).toLocaleString() }}
          </v-chip>

          <v-chip
                  class="ma-2"
                  color="green"
                  text-color="white"
          >
            Total Interest: ${{data.interestPaidArray.length > 0 ? data.interestPaidArray[data.interestPaidArray.length - 1].toLocaleString():0}}
          </v-chip>

          <v-chip
                  v-if="data.pmi"
                  class="ma-2"
                  color="orange"
                  text-color="white"
          >
            Total PMI: ${{data.pmiPaidMonthlyArray.length > 0 ? data.pmiPaidMonthlyArray[data.pmiPaidMonthlyArray.length - 1].toLocaleString():0}}
          </v-chip>

          <v-chip
                  v-if="data.pmi"
                  class="ma-2"
                  color="#FFAB40"
                  text-color="white"
          >
            PMI term: {{data.pmiCutoffMonth}}m or {{parseInt(data.pmiCutoffMonth/12)}}y {{data.pmiCutoffMonth % 12}}m
          </v-chip>

            <br />
          <v-tabs
                  v-model="tab"
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#byMonth">By Month</v-tab>
            <v-tab href="#byYear">By Year</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item
                    key="byMonth"
                    value="byMonth"
            >
              <highcharts :options="chartOptionsMonthly"></highcharts>
              <v-simple-table fixed-header height="300px">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Month</th>
                    <th>Loan Balance</th>
                    <th>Principal</th>
                    <th>Interest</th>
                    <th>Interest Paid</th>
                    <th>Principal Paid</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="i in totalMonths" :key="i">
                    <td>{{ i }}</td>
                    <td>${{ data.balanceArray[i-1].toLocaleString() }}</td>
                    <td>${{ data.principalPerMonth[i-1].toLocaleString() }}</td>
                    <td>${{ data.interestPerMonth[i-1].toLocaleString() }}</td>
                    <td>${{ data.interestPaidArray[i-1].toLocaleString() }}</td>
                    <td>${{ data.principalPaidArray[i-1].toLocaleString() }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </v-tab-item>
            <v-tab-item
                    key="byYear"
                    value="byYear"
            >
              <highcharts :options="chartOptionsYearly"></highcharts>
              <v-simple-table fixed-header height="300px">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Year</th>
                    <th>Loan Balance</th>
                    <th>Principal</th>
                    <th>Interest</th>
                    <th>Interest Paid</th>
                    <th>Principal Paid</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="i in data.term" :key="i">
                    <td>{{ i }}</td>
                    <td>${{ data.balanceYearlyArray[i-1].toLocaleString() }}</td>
                    <td>${{ data.principalPerYear[i-1].toLocaleString() }}</td>
                    <td>${{ data.interestPerYear[i-1].toLocaleString() }}</td>
                    <td>${{ data.interestPaidYearlyArray[i-1].toLocaleString() }}</td>
                    <td>${{ data.principalPaidYearlyArray[i-1].toLocaleString() }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </v-tab-item>
          </v-tabs-items>

        </v-col>
      </v-row>


    </div>
  </v-container>
</template>

<script>
  import { mapMutations } from 'vuex'

  export default {
    name: 'EachLoanOption',

    data: () => ({
      tab: 0,
      terms: [5, 10, 15, 30],
    }),
    props: {
      data: {
        type: Object,
        required: true
      },
      passedListingPrice: {
        type: Number,
        required: false
      },
      passedDownPaymentAmount: {
        type: Number,
        required: false
      },
      passedTerm: {
        type: Number,
        required: false
      }
    },
    computed: {
      totalMonths: function () {
        return Number(this.data.term) * 12;
      },
      monthlyRate: function () {
        return this.data.rate / 1200;
      },

      chartOptionsYearly: function () {
        return {
          series: [
            {
              type: 'column',
              pointStart: 1,
              visible: false,
              name: 'principal left',
              data: this.data.balanceYearlyArray,
              tooltip: {
                headerFormat: '<span style="font-size: 10px">Year {point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>${point.y}</b><br/>'
              }
            },
            {
              type: 'column',
              pointStart: 1,
              visible:false,
            name: 'principal paid',
            data: this.data.principalPaidYearlyArray,
              tooltip: {
                headerFormat: '<span style="font-size: 10px">Year {point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>${point.y}</b><br/>'
              }
          },
            {
              type: 'spline',
              pointStart: 1,
              visible:true,
              name: 'interest paid',
              data: this.data.interestPaidYearlyArray,
              tooltip: {
                headerFormat: '<span style="font-size: 10px">Year {point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>${point.y}</b><br/>'
              }
            },
            {
              type: 'spline',
              pointStart: 1,
              visible:true,
              name: 'PMI',
              data: this.data.pmiPaidYearlyArray,
              tooltip: {
                headerFormat: '<span style="font-size: 10px">Year {point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>${point.y}</b><br/>'
              }
            },
          ],
          // chart: {
          //   type: 'column'
          // },
          plotOptions: {
            column: {
              stacking: 'normal',

            }
          },
          title: {
              text: 'Loan Overview Per Year'
          },
          xAxis: {
            title: {
              text: 'Year',
              align: 'high'
            }
          }
        }
      },
      chartOptionsMonthly: function () {
        return {
          series: [
            {
              type: 'column',
              pointStart: 1,
              visible: false,
              name: 'principal left',
              data: this.data.balanceArray,
              tooltip: {
                headerFormat: '<span style="font-size: 10px">Month {point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>${point.y}</b><br/>'
              }
            },
            {
              type: 'column',
              pointStart: 1,
              visible:true,
              name: 'principal paid',
              data: this.data.principalPaidArray,
              tooltip: {
                headerFormat: '<span style="font-size: 10px">Month {point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>${point.y}</b><br/>'
              }
            },
            {
              type: 'spline',
              pointStart: 1,
              visible:true,
              name: 'interest paid',
              data: this.data.interestPaidArray,
              tooltip: {
                headerFormat: '<span style="font-size: 10px">Month {point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>${point.y}</b><br/>'
              }
            },
            {
              type: 'spline',
              pointStart: 1,
              visible:true,
              name: 'PMI',
              data: this.data.pmiPaidMonthlyArray,
              tooltip: {
                headerFormat: '<span style="font-size: 10px">Month {point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>${point.y}</b><br/>'
              }
            },
          ],
          // chart: {
          //   type: 'column'
          // },
          plotOptions: {
            column: {
              stacking: 'normal',

            }
          },
            title: {
                text: 'Loan Overview Per Month'
            },
          xAxis: {
            title: {
              text: 'Month',
              align: 'high'
            }
          }
        }
      }
    },
    mounted: function() {
      // this.updateDownPaymentPercent();
      this.calculate();
    },
    methods: {
      ...mapMutations(["setDefaultListingPrice"]),
      updateListingPrice: function () {
        this.data.downPaymentAmount = Number(this.data.listingPrice) * Number(this.data.downPaymentPercent) / 100;
        this.data.loanAmount = Number(this.data.listingPrice) - Number(this.data.downPaymentAmount);
        this.setDefaultListingPrice(this.data.listingPrice);
      },
      updateDownPaymentAmount: function () {
          this.data.downPaymentPercent = Number(this.data.downPaymentAmount) / Number(this.data.listingPrice) * 100;
          this.data.loanAmount = Number(this.data.listingPrice) - Number(this.data.downPaymentAmount);
          },
      updateDownPaymentPercent: function () {
          this.data.downPaymentAmount = Number(this.data.listingPrice) * Number(this.data.downPaymentPercent) / 100;
        this.data.loanAmount = Number(this.data.listingPrice) - Number(this.data.downPaymentAmount);
          this.data.pmiPaidMonthlyArray = [];
          this.data.pmiPaidYearlyArray = [];
          // if(this.data.downPaymentPercent >= 20) {
          //   this.data.pmi = 0;
          // }else{
          //   this.data.pmi = 50 + Math.round(Math.random()*100);
          // }
      },
      updateLoanAmount: function () {
        this.data.downPaymentAmount = Number(this.data.listingPrice) - Number(this.data.loanAmount);
        this.data.downPaymentPercent = Number(this.data.downPaymentAmount) / Number(this.data.listingPrice) * 100;
      },
      calculateMonthlyPayment: function() {
        var x = Math.pow(1+this.monthlyRate, this.totalMonths);
        this.data.monthlyPayment = (this.data.loanAmount * this.monthlyRate * x / (x -1));
      },
      calculate: function () {
        this.reset();
        this.calculateMonthlyPayment();
        this.calculateMonthArrays();
      },
      calculateMonthArrays: function () {
        // var principalPaidWithoutExtra = [];
        var interestPaidWithoutExtra = [];
        var balanceWithoutExtra = [this.data.loanAmount];
        for (var i = 0; i < this.totalMonths; i++){
          this.data.interestPerMonth.push(this.roundNumber((this.data.balanceArray[i] * this.monthlyRate)));
          this.data.principalPerMonth.push(
                  this.roundNumber(this.data.monthlyPayment - this.data.interestPerMonth[i] + Number(this.data.extraPerMonth)));

          //without extra
          var interestThisMonth = this.roundNumber(balanceWithoutExtra[i] * this.monthlyRate);
          var principalThisMonth = this.roundNumber(this.data.monthlyPayment - interestThisMonth);
          
          var balance = this.roundNumber(this.data.balanceArray[i] - this.data.principalPerMonth[i])> 0 ? this.roundNumber(this.data.balanceArray[i] - this.data.principalPerMonth[i]) : 0;
          this.data.balanceArray.push(balance);

          //without extra
          balanceWithoutExtra.push( this.roundNumber(balanceWithoutExtra[i] - principalThisMonth)> 0 ? this.roundNumber(balanceWithoutExtra[i] - principalThisMonth) : 0);

          if(i == 0){
            this.data.principalPaidArray.push(this.roundNumber(this.data.principalPerMonth[i]));
            this.data.interestPaidArray.push(this.roundNumber(this.data.interestPerMonth[i]));
            //without extra
            // principalPaidWithoutExtra.push(this.roundNumber(principalThisMonth));
            interestPaidWithoutExtra.push(this.roundNumber(interestThisMonth));
          }else {
            var principal = this.roundNumber(this.data.principalPaidArray[i-1]) + this.roundNumber(this.data.principalPerMonth[i]);
            if(principal > this.data.loanAmount) {
              principal = this.data.loanAmount;
              if (this.data.payoffMonth == 0) {
                this.data.payoffMonth = this.totalMonths - i - 1;
              }
            }
            this.data.principalPaidArray.push(principal);
            this.data.interestPaidArray.push((this.roundNumber(this.data.interestPaidArray[i-1]) + this.roundNumber(this.data.interestPerMonth[i])));
            //without extra
            // principalPaidWithoutExtra.push(this.roundNumber(principalPaidWithoutExtra[i-1] + principalThisMonth));
            interestPaidWithoutExtra.push(this.roundNumber(interestPaidWithoutExtra[i-1]) + this.roundNumber(interestThisMonth));
          }

          //pmi
          if (this.data.pmi!=0){
            if ((this.data.principalPaidArray[i]+this.data.downPaymentAmount)/this.data.listingPrice>0.2){
               // this.data.pmiPaidMonthlyArray.push(0);
              if(this.data.pmiCutoffMonth == 0){
                this.data.pmiCutoffMonth = i;
              }
            }else{
              this.data.pmiPaidMonthlyArray.push(this.data.pmi*(i+1));
            }
          }

          // 1+11%12 = 0  1+23%12 = 0
          if ((1+i)%12 == 0){
            this.data.interestPerYear.push(this.getYearAmountFromMonth(this.data.interestPerMonth, i-11, i));
            this.data.principalPerYear.push(this.getYearAmountFromMonth(this.data.principalPerMonth, i-11, i));
            this.data.principalPaidYearlyArray.push(this.data.principalPaidArray[i]);
            this.data.interestPaidYearlyArray.push(this.data.interestPaidArray[i]);
            this.data.balanceYearlyArray.push(this.data.balanceArray[i]);
            if(this.data.pmiPaidMonthlyArray[i])
            {
              this.data.pmiPaidYearlyArray.push(this.data.pmiPaidMonthlyArray[i]);
            }
          }
        }
        this.data.originalInterest = interestPaidWithoutExtra[interestPaidWithoutExtra.length-1];
      },
      getYearAmountFromMonth: function (array, start, end) {
        var sum = 0;
        for (var i = start; i < end+1; i++){
          sum += array[i];
        }
        return sum;
      },
      roundNumber: function (number) {
        return Math.round(number);
      },
      reset: function () {
        this.data.interestPerMonth = [];
        this.data.principalPerMonth = [];
        this.data.balanceArray =  [];
        this.data.balanceArray.push(Number(this.data.loanAmount));
        this.data.principalPaidArray = [];
        this.data.interestPaidArray = [];
        this.data.pmiPaidMonthlyArray = [];
        this.data.monthlyPIRate = [];

        this.data.balanceYearlyArray = [];
        this.data.principalPaidYearlyArray = [];
        this.data.principalPerYear = [];
        this.data.interestPaidYearlyArray = [];
        this.data.interestPerYear = [];
        this.data.pmiPaidYearlyArray = [];
        this.data.yearlyPIRate = [];

        this.originalInterest = 0;
        this.data.pmiCutoffMonth = 0;
        this.data.payoffMonth = 0;
      }
    }
  }
</script>
